import moment from 'moment'
import services from './services'
import ft from './featureToggle'

export default {
  getPackage (VueApp, id, callback) {
    let self = this
    VueApp.$sdk.get('/admin/package/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      if (r.error) {
        callback(r)
        return
      }

      if (r.rsvp.length <= 0) {
        callback({
          error: 'Dead Package'
        })
        return
      }

      callback(self.formatPackage(VueApp, r))
    })
  },

  formatRsvp (VueApp, item) {
    let driver = null
    if (item.provider.ID !== null) {
      driver = {
        id: item.provider.ID,
        driverNum: item.provider.driverNum || item.provider.ID,
        firstName: item.provider.firstName,
        lastName: item.provider.lastName,
        email: item.provider.email,
        phone: item.provider.displayPhone,
        photoUrl: item.provider.avatarUrl
      }
    }
    let flight = null
    if (item.airline !== null && item.fligtNumber !== null) {
      flight = item.airline + ' ' + item.flightNumber
    }

    let guest = null
    if (item.guest.firstName !== null && item.guest.firstName !== '') {
      guest = {
        firstName: item.guest.firstName,
        lastName: item.guest.lastName,
        phone: item.guest.phone
      }
    }

    let statusClass = item.dispatchStatus
    let status = item.dispatchStatus.toUpperCase()
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch'
      status = 'REQUIRES DISPATCH'
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch'
      status = 'AUTO DISPATCH'
    }

    if (statusClass === 'complete') {
      status = 'COMPLETED'
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO'
    }

    let serviceType = item.serviceCode.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
    if (serviceType === 'Suv') {
      serviceType = 'SUV'
    }
    let serviceLabel = services.getServiceName(item.serviceCode)
    let serviceBg = ''
    if (item.optinShared && item.optinShared.isOptinShared) {
      serviceLabel = item.serviceType.name
      serviceBg = item.serviceType.color
    }

    let completedTime = null
    if (item.complete) {
      completedTime = moment(item.complete, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY hh:mmA')
    }

    return {
      isPackage: false,
      airportFee: item.airportFee,
      id: item.ID,
      pickup: {
        address1: item.pickupLocation.addressLine1,
        address2: item.pickupLocation.addressLine2,
        city: item.pickupLocation.city,
        state: item.pickupLocation.state,
        zip: item.pickupLocation.zip,
        lat: item.pickupLocation.lat,
        lng: item.pickupLocation.lng,
        geofenceName: item.pickupLocation.geofenceName,
        geofenceType: item.pickupLocation.geofenceType,
        terminal: item.terminal,
        title: item.pickupLocation.title
      },
      dropoff: {
        address1: item.dropoffLocation.addressLine1,
        address2: item.dropoffLocation.addressLine2,
        city: item.dropoffLocation.city,
        state: item.dropoffLocation.state,
        zip: item.dropoffLocation.zip,
        lat: item.dropoffLocation.lat,
        lng: item.dropoffLocation.lng,
        geofenceName: item.dropoffLocation.geofenceName,
        geofenceType: item.dropoffLocation.geofenceType,
        title: item.dropoffLocation.title
      },
      pickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      status: status,
      statusClass: statusClass,
      rsvpStatus: item.status,
      customer: {
        id: item.consumer.ID,
        firstName: item.consumer.firstName,
        lastName: item.consumer.lastName,
        email: item.consumer.email,
        phone: item.consumer.displayPhone
      },
      guest: guest,
      driver: driver,
      meetAndGreet: item.pickupType === 'MeetAndGreet',
      airline: item.airline,
      airlineCode: item.airlineCode,
      flightNumber: item.flightNumber,
      flight: flight,
      ada: item.ada ? item.ada : null,
      pax: item.passengers,
      luggage: item.luggage === null ? 0 : item.luggage,
      stops: 1,
      serviceType: serviceType,
      serviceLabel: serviceLabel,
      serviceBg: serviceBg,
      serviceClass: item.serviceCode,
      distance: item.distance,
      etaInSec: item.etaInSec,
      fare: item.payment.fareAmount,
      driverPayment: {
        base: item.payment.driverPay === null ? 0 : item.payment.driverPay,
        bonus: item.payment.driverBonus === null ? 0 : item.payment.driverBonus,
        tip: item.payment.tipAmount === null ? 0 : item.payment.tipAmount,
        pickupFee: item.payment.pickupFee === null ? 0 : item.payment.pickupFee
      },
      completed: completedTime,
      optinShared: item.optinShared || null
    }
  },

  formatPackage (VueApp, item) {
    let self = this
    let firstRsvp = item.rsvp.filter(rsvp => rsvp.ID === item.stops[0].reservationID)[0]
    let lastRsvp = item.rsvp.filter(rsvp => rsvp.ID === item.stops[item.stops.length - 1].reservationID)[0]

    let statusClass = item.package.packageStatus ?
                      item.package.packageStatus :
                      item.package.status
    let status = item.package.packageStatus ?
                 item.package.packageStatus.toUpperCase() :
                 item.package.status.toUpperCase()

    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch'
      status = 'REQUIRES DISPATCH'
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch'
      status = 'AUTO DISPATCH'
    }

    if (statusClass === 'cancelled') {
      statusClass = 'canceled'
      status = 'CANCELED'
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO'
    }

    let luggage = 0
    let fare = 0
    let driverPayment = {
      base: item.package.paidForProvider,
      bonus: item.package.bonusToProvider !== null ? item.package.bonusToProvider : 0,
      tip: 0,
      pickupFee: 0,
      gasFee: 0
    }
    let ada = {
      serviceDog: 0,
      wheelChairLift: 0
    }
    let reservations = []
    let airportFee = 0
    let tranvelInsurance = 0
    for (let i = 0; i < item.rsvp.length; i++) {
      let rsvp = item.rsvp[i]
      luggage += (rsvp.luggage === null ? 0 : rsvp.luggage)
      fare += rsvp.payment.fareAmount
      fare += (rsvp.payment.tipAmount === null ? 0 : rsvp.payment.tipAmount)
      // driverPayment.base += (rsvp.payment.driverPay === null ? 0 : rsvp.payment.driverPay)
      driverPayment.tip += (rsvp.payment.tipAmount === null ? 0 : rsvp.payment.tipAmount)
      driverPayment.pickupFee += (rsvp.payment.pickupFee === null ? 0 : rsvp.payment.pickupFee)
      driverPayment.gasFee += (rsvp.gasFee === null ? 0 : rsvp.gasFee)

      rsvp.serviceCode = 'shared'
      reservations.push(self.formatRsvp(VueApp, rsvp))

      if (rsvp.travelInsurance !== null) {
        tranvelInsurance += rsvp.travelInsurance
      }

      if (rsvp.airportFee !== null) {
        airportFee += rsvp.airportFee
      }

      if (rsvp.ada.serviceDog === 1) {
        ada.serviceDog = 1
      }
      if (rsvp.ada.wheelChairLift === 1) {
        ada.wheelChairLift = 1
      }
    }

    let route = []
    let legs = []
    for (let i = 0; i < item.stops.length; i++) {
      let rsvp = item.rsvp.filter(rsvp => rsvp.ID === item.stops[i].reservationID)[0]
      let location = rsvp.dropoffLocation
      if (item.stops[i].isPickup) {
        location = rsvp.pickupLocation
      }
      route.push({
        rsvpID: rsvp.ID,
        isPickup: item.stops[i].isPickup,
        address1: location.addressLine1,
        address2: location.addressLine2,
        city: location.city,
        state: location.state,
        zip: location.zip,
        lat: location.lat,
        lng: location.lng,
        geofenceName: location.geofenceName,
        geofenceType: location.geofenceType,
        status: rsvp.dispatchStatus,
        guestName: rsvp.guest.firstName ? `${rsvp.guest.firstName} ${rsvp.guest.lastName}` : `${rsvp.consumer.firstName} ${rsvp.consumer.lastName}`
      })

      let leg = self.formatRsvp(VueApp, rsvp)
      leg.isPickup = item.stops[i].isPickup
      leg.arrivalTime = moment.tz(item.package.pickupTime, 'YYYY-MM-DD@HH:mm', 'America/Los_Angeles').add(item.stops[i].eta, 'seconds').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))

      legs.push(leg)
    }

    let driver = null
    if (item.driver != null) {
      driver = {
        id: item.driver.ID,
        driverNum: item.driver.driverNum || item.driver.ID,
        firstName: item.driver.firstName,
        lastName: item.driver.lastName,
        email: item.driver.email,
        phone: item.driver.phone,
        photoUrl: item.driver.avatarUrl,
        vehicle: {
          name: `${item.driver.vehicle.manufacturer} ${item.driver.vehicle.model}`,
          photoUrl: item.driver.vehicle.photo,
          licensePlate: item.driver.vehicle.licensePlate
        }
      }
    }
    return {
      isPackage: true,
      airportFee: airportFee,
      id: item.package.id,
      pickup: {
        address1: firstRsvp.pickupLocation.addressLine1,
        address2: firstRsvp.pickupLocation.addressLine2,
        city: firstRsvp.pickupLocation.city,
        state: firstRsvp.pickupLocation.state,
        zip: firstRsvp.pickupLocation.zip,
        lat: firstRsvp.pickupLocation.lat,
        lng: firstRsvp.pickupLocation.lng,
        geofenceName: firstRsvp.pickupLocation.geofenceName,
        geofenceType: firstRsvp.pickupLocation.geofenceType,
        title: firstRsvp.pickupLocation.title
      },
      dropoff: {
        address1: lastRsvp.dropoffLocation.addressLine1,
        address2: lastRsvp.dropoffLocation.addressLine2,
        city: lastRsvp.dropoffLocation.city,
        state: lastRsvp.dropoffLocation.state,
        zip: lastRsvp.dropoffLocation.zip,
        lat: lastRsvp.dropoffLocation.lat,
        lng: lastRsvp.dropoffLocation.lng,
        geofenceName: lastRsvp.dropoffLocation.geofenceName,
        geofenceType: lastRsvp.dropoffLocation.geofenceType,
        title: lastRsvp.dropoffLocation.title
      },
      pickupTime: moment(item.package.localPickupTime).format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      status: status,
      statusClass: statusClass,
      customer: null,
      guest: null,
      driver: driver,
      meetAndGreet: false,
      airline: null,
      airlineCode: null,
      flightNumber: null,
      flight: null,
      ada: ada,
      pax: item.package.pax,
      luggage: luggage,
      rsvps: reservations,
      stops: item.package.stops / 2,
      legs: legs,
      route: route,
      serviceType: 'Shared',
      serviceLabel: services.getServiceName('shared'),
      serviceClass: 'shared',
      fare: fare,
      driverPayment: driverPayment,
      tranvelInsurance: tranvelInsurance
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/package.js